if (document.getElementById("newsSearch")) {

  var options = {
      data: autocompleteData,
      getValue: "name",
      template: {
          type: "custom",
          method: function(value, item) {
              return "<a href='" + item.link + "' class='" + item.icon + "'>" + value +"</a>";
          }
      },
      list: {
          maxNumberOfElements: 1000,
          match: {
              enabled: true,
          },
          onLoadEvent: function () {
              if ($("#eac-container-search-autocomplete").val() !== '') {
                  var elementCount = $("#eac-container-search-autocomplete").getElementCount();
                  if (elementCount <= 0) {
                      $('#no-results').show();
                  }
                  else {
                      $('#no-results').hide();
                  }
              }
          }
      },
      highlightPhrase: false,
      noResults: 'No results found, please try again',
  };

  function autocomplete(inp, arr) {

      /*the autocomplete function takes two arguments,
      the text field element and an array of possible autocompleted values:*/
      var currentFocus;

      /*execute a function when someone writes in the text field:*/
      inp.addEventListener("input", function(e) {

          var a, b, i, val = this.value;
          /*close any already open lists of autocompleted values*/
          closeAllLists();

          if (!val) { return false;}

          let newsOrig = document.getElementsByClassName('news-opinions-all__posts');

          currentFocus = -1;
          /*create a DIV element that will contain the items (values):*/
          a = document.createElement("DIV");
          a.setAttribute("id", "autocomplete-list");
          a.setAttribute("class", "news-opinions-all__posts");
          /*append the DIV element as a child of the autocomplete container:*/
          newsOrig[0].parentNode.appendChild(a);

          ii = 1;

          /*for each item in the array...*/
          for (i = 0; i < arr.length; i++) {
            /*check if the item starts with the same letters as the text field value:*/
            if (arr[i].name.substr(0, val.length).toUpperCase() == val.toUpperCase()) {
              /*create a DIV element for each matching element:*/

              b = document.createElement("a");
              /*make the matching letters bold:*/
              b.innerHTML = "<div class='image'><img src='" + arr[i].icon + "'></div>";
              b.innerHTML += "<span>" + arr[i].catName + "</span>";
              b.innerHTML += "<h3 class='blue-title'>" + arr[i].name + "</h3>";
              /*insert a input field that will hold the current array item's value:*/
              b.innerHTML += "<input type='hidden' value='" + arr[i].name + "'>";
              /*execute a function when someone clicks on the item value (DIV element):*/
              b.addEventListener("click", function(e) {
                  /*insert the value for the autocomplete text field:*/
                  inp.value = this.getElementsByTagName("input")[0].value;
                  /*close the list of autocompleted values,
                  (or any other open lists of autocompleted values:*/
                  closeAllLists();
              });
              a.appendChild(b);
            } else {

              if (ii == arr.length) {
                a.innerHTML = 'No Results Found';
              }

              ii = ii + 1;
            }
          }
      });

      /*execute a function presses a key on the keyboard:*/
      inp.addEventListener("keydown", function(e) {
          var x = document.getElementById(this.id + "autocomplete-list");
          if (x) x = x.getElementsByTagName("div");
          if (e.keyCode == 40) {
            /*If the arrow DOWN key is pressed,
            increase the currentFocus variable:*/
            currentFocus++;
            /*and and make the current item more visible:*/
            addActive(x);
          } else if (e.keyCode == 38) { //up
            /*If the arrow UP key is pressed,
            decrease the currentFocus variable:*/
            currentFocus--;
            /*and and make the current item more visible:*/
            addActive(x);
          } else if (e.keyCode == 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            e.preventDefault();
            if (currentFocus > -1) {
              /*and simulate a click on the "active" item:*/
              if (x) x[currentFocus].click();
            }
          }
      });

      function addActive(x) {
        /*a function to classify an item as "active":*/
        if (!x) return false;
        /*start by removing the "active" class on all items:*/
        removeActive(x);
        if (currentFocus >= x.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = (x.length - 1);
        /*add class "autocomplete-active":*/
        x[currentFocus].classList.add("autocomplete-active");
      }

      function removeActive(x) {
        /*a function to remove the "active" class from all autocomplete items:*/
        for (var i = 0; i < x.length; i++) {
          x[i].classList.remove("autocomplete-active");
        }
      }

      function closeAllLists(elmnt) {
        /*close all autocomplete lists in the document,
        except the one passed as an argument:*/
        var x = document.getElementsByClassName("news-opinions-all__posts");
        var xOrig = document.getElementsByClassName("news-opinions-all__posts original");
        var pag = document.getElementById('newsPostsPaginationContainer');

        for (var i = 0; i < x.length; i++) {
            if (x[i].classList.contains('original')) {
              if (document.getElementById("newsSearch").value == '' || document.getElementById("newsSearch").value == null ) {
                xOrig[0].classList.remove('hidden');
                pag.classList.remove('hidden');
              } else {
                x[i].classList.add('hidden');
                pag.classList.add('hidden');
              }
            } else {
                x[i].remove();
            }
          }
      }
  }

  autocomplete(document.getElementById("newsSearch"), options.data);

}

